import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser'
import { Router } from "@angular/router";
import { AccountService } from "app/account/account.service";
import { MemberService } from "app/member/member.service";
import * as $ from 'jquery';
import { RestService } from "app/webservice/rest.service";
import { environment } from "environments/environment";
import { ToastsManager } from "ng2-toastr";
import { PlatformLocation } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public serviceStackUrl;
  public currentRoute = '/';
  public loggedIn = false;
  public searchingMembers: boolean = false;
  public checkingInAssets: boolean = false;
  public checkInAssetFailed: boolean = false;
  public checkInAssetError: string = ''
  public search={
    BarcodeId: null,
    Phones:[{Number: ''}],
    FirstName: '',
    LastName: ''
  }

  @ViewChild('checkInModal') checkInModal;
  @ViewChild('memberLookupModal') memberLookupModal;
  @ViewChild('scannerInput') scannerInput;
  @ViewChild('renewalInput') renewalInput;
  @ViewChild('scannerMemberBarcodeInput') scannerMemberBarcodeInput;
  @ViewChild('scannerMemberPhoneInput') scannerMemberPhoneInput;
  @ViewChild('scannerMemberFirstNameInput') scannerMemberFirstNameInput;
  @ViewChild('scannerMemberLastNameInput') scannerMemberLastNameInput;
  
  constructor(
    private router: Router, 
    private _accountService: AccountService, 
    private _restService:RestService, 
    private memberService:MemberService, 
    private _toastr: ToastsManager,
    platformLocation: PlatformLocation, 
    vcr: ViewContainerRef
  ) {
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
    this._toastr.setRootViewContainerRef(vcr);
    this.router.events.subscribe((url:any) => this.currentRoute = router.url);
    this._accountService.authToken.subscribe(token => {
      if (token !== "") {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    });
  }

  logout() {
    this._accountService.clearAccount();
    this.router.navigate(['/login']);
  }

  checkInAsset(e) {
    e.preventDefault();
    this.checkingInAssets = true;
    let barcode = this.scannerInput.nativeElement.value;
    let IsRenewal = $('#renewalInput').is(':checked');
    let url = this.serviceStackUrl + 'Asset-CheckIn';
    let checkInObject = {"Barcode":barcode, "IsRenewal":IsRenewal};
    this._restService.post(url, checkInObject).then(response => {
      this.checkingInAssets = false;
      if (response.Success) {
        this._toastr.success('Check In Successful!')
      } else {
        if (response.Errors && response.Errors.length) {
          this.checkInAssetFailed = true;
          this.checkInAssetError = response.Errors[0].Message;
          this._toastr.error(this.checkInAssetError);
        }
      }
      setTimeout(() => {
        $('#checkinInput').val('');
        $('#renewalInput').prop('checked', false);
        $('#checkinInput').focus();
      }, 100);
    })
    .catch((err) => {
      console.log(err);
      this.checkingInAssets = false;
    })
  }

  checkIn() {
    this.checkInAssetError = '';
    this.checkInModal.show();
    setTimeout(() => {
      $('#checkinInput').val('');
      $('#renewalInput').prop('checked', false);
      $('#checkinInput').focus();
    }, 500);
  }

  lookupMembers(e) {
    this.searchingMembers = true;
    console.log('find member');
    e.preventDefault();
    let barcode = this.scannerMemberBarcodeInput.nativeElement.value;
    let phone = this.scannerMemberPhoneInput.nativeElement.value;
    let first = this.scannerMemberFirstNameInput.nativeElement.value;
    let last = this.scannerMemberLastNameInput.nativeElement.value;
    this.search.BarcodeId = parseInt(barcode);
    if (this.validatePhone(phone) === false) {
      this._toastr.error('Please enter a valid phone number');
    } else {
      let url = this.serviceStackUrl + 'Member-GetMembersByQuery';
      this.search.Phones[0].Number = this.validatePhone(phone);
      this.search.FirstName = first;
      this.search.LastName = last;
      if (this.search.LastName.length) {
        this.search.LastName = "*" + this.search.LastName + "*";
      }
      if (this.search.FirstName.length) {
        this.search.FirstName = "*" + this.search.FirstName + "*";
      }
      let quickSearchObject = {EntityDto: this.search};
      this._restService.post(url, quickSearchObject).then(response => {
        this.search.LastName = this.search.LastName.substr(1).slice(0, -1);
        this.search.FirstName = this.search.FirstName.substr(1).slice(0, -1);
        if (response.Success) {
          if (response.Data.length === 0) {
            this._toastr.error("No Members Found.");
          } else if (response.Data.length === 1) {
            this.memberLookupModal.hide();
            this.router.navigate(['/member/'+response.Data[0].Oid]);
          } else if (response.Data.length > 1) {
            this.memberService.foundMembers.next(response.Data);
            this.memberLookupModal.hide();
            this.router.navigate(['/member/search']);
          }
        } else {
          console.log(response);
        }
        this.searchingMembers = false;
        setTimeout(() => {
          $('#lookupBarcodeInput').val('');
          $('#lookupPhoneInput').val('');
          $('#lookupFirstNameInput').val('');
          $('#lookupLastNameInput').val('');
          $('#lookupBarcodeInput').focus();
        }, 100);
      })
    }    
  }

  validatePhone(phone) {
    return this.memberService.formatPhone(phone);
  }

  memberLookup() {
    this.memberLookupModal.show();
    setTimeout(() => {
      $('#lookupBarcodeInput').focus();
    }, 500);
  }
}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/app.component.ts